import { createTheme } from '@mui/material';
import { commonTheme } from './common';

export const darkTheme = createTheme({
  ...commonTheme,
  palette: {
    mode: 'dark',
    background: {
      default: '#0077cc',
    },
    text: {
      primary: '#ffffff',
    },
  },
});
